import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Phone({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4999 16.92C21.5128 16.3876 21.143 15.9511 20.6492 15.8814C19.6143 15.7449 18.5983 15.4918 17.6181 15.126C17.2526 14.9887 16.8407 15.0765 16.567 15.3471L15.2971 16.6171C14.9787 16.9354 14.487 17.0018 14.0956 16.7793C11.4356 15.2667 9.23318 13.0643 7.72065 10.4043C7.49814 10.0129 7.56452 9.52118 7.88284 9.20287L9.14889 7.93684C9.4234 7.65924 9.51126 7.24728 9.37305 6.87958C9.00813 5.90165 8.75501 4.88557 8.61979 3.85993C8.54954 3.36291 8.12172 2.99499 7.60994 2.99998L4.61089 2.99998C4.33018 3.00024 4.06252 3.11847 3.87327 3.32579C3.68402 3.5331 3.59062 3.81041 3.61435 4.07438C3.92601 7.00918 4.9246 9.82931 6.53396 12.3137C7.99056 14.6059 9.934 16.5494 12.234 18.011C14.6998 19.61 17.5063 20.6084 20.41 20.924C20.6904 20.9494 20.9685 20.8553 21.176 20.665C21.3835 20.4746 21.5011 20.2056 21.4999 19.92V16.92ZM23.4999 19.9159C23.5034 20.7606 23.1505 21.5677 22.5281 22.1387C21.9056 22.7098 21.0712 22.992 20.2119 22.9141C16.9793 22.5629 13.8741 21.4582 11.1536 19.694C8.61354 18.0799 6.46 15.9264 4.85066 13.3937C3.07524 10.6531 1.97036 7.53276 1.624 4.26998C1.54821 3.43129 1.82841 2.59936 2.39615 1.97741C2.96389 1.35546 3.76689 1.00077 4.60994 0.999977L7.6001 1.00003C9.1059 0.985205 10.3894 2.08898 10.6014 3.58922C10.7181 4.47451 10.9347 5.34376 11.246 6.17812C11.6581 7.27443 11.3945 8.51033 10.5671 9.34708L9.84996 10.0642C11.0258 11.9088 12.5911 13.4741 14.4358 14.65L15.1568 13.9289C15.9896 13.1054 17.2255 12.8418 18.3195 13.2531C19.1562 13.5653 20.0254 13.7818 20.9196 13.8998C22.4235 14.1119 23.5308 15.4142 23.4999 16.9312L23.4999 19.9159Z"
          fill="#768190"
        />
      </svg>
    </div>
  )
}

Phone.propTypes = {
  className: PropTypes.string,
}
